import { getLatLngFromAddress } from 'utilities';
import { useEffect, useState } from 'react';
import { useMapperAddress } from './useMapperAddress';

const useSetLocation = () => {
  const [click, setClick] = useState<any>();
  const {
    getLongAddress,
    location: { locationLat, currentLat, currentLng, locationLong },
  } = useMapperAddress();

  useEffect(() => {
    if (!locationLat)
      getLatLngFromAddress(getLongAddress()).then((resp) => {
        setClick({
          lng: resp.lng || currentLng,
          lat: resp.lat || currentLat,
        });
      });
    else
      setClick({
        lng: locationLong || currentLng,
        lat: locationLat || currentLat,
      });
  }, [currentLat, currentLng, getLongAddress, locationLat, locationLong]);

  return { click };
};

export default useSetLocation;
